import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'leimma1';
const args = {};

export class Leimma1 extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
